module.exports = __webpack_public_path__ + "static/media/pic2.eeb55d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic2.png
// module id = 231
// module chunks = 0